var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNserixPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 133,
    viewBox: "0 0 664 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_2187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.74 6.4C130.82 8.92 126.17 11.99 122.07 15.7C114.39 22.64 109.89 30.42 109.89 41.24V66.16C109.89 74.99 112.65 83.6 117.79 90.78L120.34 94.34C123.96 99.4 128.67 103.62 134.24 106.39C135.34 106.94 136.43 107.41 137.51 107.79C141.34 109.14 144.44 108.85 146.52 106.41C147.89 103.4 148.22 100.05 148.22 96.41V0L135.74 6.4Z",
    fill: "url(#paint0_linear_57_2187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.86 76.71C98.26 99.4 128.65 111.79 143.78 108.43V108.27C142.03 108.84 139.91 108.64 137.5 107.8C128.9 104.72 119.55 96.26 109.95 85.97L64.27 33.89C43.74 10.54 14.02 10.38 1.95996 33.35C4.57996 30.54 8.55996 29.79 13.03 31.56C24.23 35.61 46.73 60.94 67.86 76.71Z",
    fill: "url(#paint1_linear_57_2187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.67 55.54L23.54 39.91C21.66 37.63 19.81 35.72 18.01 34.19C16.18 32.99 14.51 32.09 13.03 31.55C8.55 29.79 4.58 30.53 1.96 33.34C0.36 36.49 0 40.03 0 43.9V132.8L12.48 126.4C17.4 123.88 22.05 120.81 26.15 117.1C33.83 110.16 38.33 102.38 38.33 91.56V65.62C38.33 62.18 37.77 58.77 36.68 55.52L36.67 55.54Z",
    fill: "url(#paint2_linear_57_2187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5298 39.9101L76.0798 102.43C85.0898 113.05 94.8898 120.81 106.26 123.04C124.38 126.41 140.3 121.37 146.66 106.24C145.86 107.24 144.89 107.9 143.78 108.26V108.42C128.64 111.78 98.2498 99.3901 67.8498 76.7001C46.7298 60.9401 24.2298 35.6101 13.0298 31.5601C16.3698 32.8801 19.9898 35.6001 23.5398 39.9101H23.5298Z",
    fill: "url(#paint3_linear_57_2187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.49 101.3H240.67L195.81 54.0699H195.54V101.3H179.46V35.1599H198.26L243.06 82.4699L243.41 82.4899V35.1699H259.49V101.31V101.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.8 53.8C332.66 48.87 322.98 46.4 312.75 46.4C298.8 46.4 291.83 48.72 291.83 53.34C291.83 55.59 293.75 57.18 297.59 58.09C300.03 58.7 303.71 59.09 308.64 59.28C316.01 59.64 320.67 59.92 322.62 60.1C333.34 61.07 341.04 63.02 345.73 65.95C350.78 69 353.31 73.69 353.31 80.02C353.31 87.27 349.99 92.89 343.35 96.87C336.71 100.86 327.15 102.85 314.66 102.85C298.03 102.85 283.72 98.71 271.72 90.43L280.49 79.65C291.64 86.47 303.27 89.88 315.39 89.88C321.91 89.88 327.05 89.03 330.83 87.32C334.42 85.62 336.22 83.39 336.22 80.65C336.22 77.91 334.21 76.3 330.19 75.44C327.94 74.95 322.39 74.53 313.56 74.16C300.28 73.61 290.66 71.88 284.69 68.95C278.29 65.91 275.1 61.15 275.1 54.7C275.1 48.25 278.3 42.95 284.69 39.17C291.09 35.39 300.19 33.51 312.01 33.51C328.15 33.51 341.12 36.74 350.93 43.19L341.79 53.79L341.8 53.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.11 101.3H366.84V35.1599H438.55V47.8599H382.91V61.3799H421.55V74.0799H382.91V88.6099H441.1V101.31L441.11 101.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.92 101.3H515.77L499.55 77.9099H469.15V101.3H453.07V35.1599H507.24C514.73 35.1599 520.76 37.1599 525.33 41.1399C529.9 45.1299 532.18 50.3499 532.18 56.8099C532.18 67.3499 527.16 73.9899 517.11 76.7299L533.92 101.3ZM505.51 65.2199C508.92 65.2199 511.57 64.4299 513.46 62.8399C515.35 61.2599 516.29 59.0899 516.29 56.3499C516.29 53.7899 515.32 51.7399 513.37 50.1799C511.42 48.6299 508.77 47.8499 505.42 47.8499H469.15V65.2099H505.51V65.2199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.7 101.3H545.62V35.1599H561.7V101.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.64 61.3101L609.94 71.2201L642.43 101.3H663.83L620.64 61.3101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.8 45.7199L596.76 39.1999C593.95 36.5999 590.27 35.1599 586.44 35.1599H570.99L599.24 61.3099L603.8 57.0799C607.11 54.0199 607.11 48.7799 603.8 45.7199Z",
    fill: "url(#paint4_linear_57_2187)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.67 35.1599L591.23 101.3H569.83L641.27 35.1599H662.67Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_2187",
    x1: 129.05,
    y1: -6.53,
    x2: 129.05,
    y2: 105.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4554FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_2187",
    x1: 120.1,
    y1: 112.77,
    x2: 19.75,
    y2: 21.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4554FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_2187",
    x1: 19.16,
    y1: 36.71,
    x2: 19.16,
    y2: 136.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4554FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_57_2187",
    x1: 4.26979,
    y1: 36.7801,
    x2: 147.66,
    y2: 130.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4554FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_57_2187",
    x1: 572.95,
    y1: 27.5199,
    x2: 604.71,
    y2: 56.3499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4554FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_2187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 663.83,
    height: 132.81,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNserixPrimary);
export default __webpack_public_path__ + "static/media/nserix-primary.284ce00a394c027d379a29eb907e36d3.svg";
export { ForwardRef as ReactComponent };